import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service'

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.scss']
})
export class PrivacyComponent implements OnInit {

  privacyHtml: any;  

  constructor(
    private apiService: ApiConnectionService
  ) { }

  ngOnInit() {
    let _ = this;
  }

  ngAfterViewInit(){
    let _ = this;
    _.getPrivacy();
  }

  getPrivacy(){
    let _ = this;
    let privacyWrapper = document.querySelector(".privacy-wrapper");
    let conditions = {
      "conditions":{
        "url": "aviso_de_privacidad",
      },
      "race_id": "da2087e9-4cc7-4dcb-ae9b-597346443f5a",
      "merchant": "recaudia"
    }
    _.apiService.getPages(conditions).subscribe(data => {
      privacyWrapper.innerHTML = data['results'][0].html;
    })
  }
}
